<div class="frame-1">
  <div class="frame-4">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="44"
      width="40"
      viewBox="0 0 448 512"
      class="success-details"
    >
      <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
      <path
        fill="#a850b0"
        d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
      />
    </svg>
    <div class="text-wrapper-4">Password Updated</div>
    <p class="success-details">Your password has been updated successfully.</p>
  </div>
</div>
